// import axios from "axios";
import React from "react";
import { useHistory } from "react-router";
// import { baseUrl, mainBaseUrl } from "../../App";
import "../Styles/UserSection.scss";

const AcceptButton = ({ eventID, isVerified, getInfo, eventData }) => {
  const history = useHistory();

  const router = () => {
    history.push(`/leadTemp`, {
      eventID: eventID,
      eventData: eventData,
    });
  };

  return (
    <div className="allBtn">
      <button
        disabled={isVerified}
        // onClick={getStatus}
        onClick={() => router()}
        className="adminButton"
        type="submit"
        style={{
          backgroundColor: isVerified ? "#e6e6e6" : "##1f0e32",
          color: isVerified ? "black" : "white",
        }}
      >
        {/* {statusData.leadOK === true && statusData.certificateOK === true
          ? "Verified"
          : isVerified
          ? "Verified"
          : "Verify"} */}
        {isVerified ? "Verified" : "Verify"}
      </button>

      {/* <button onClick={getStatus} className="adminButton" type="submit">
        Email
      </button> */}
    </div>
  );
};

export default AcceptButton;
